/**
 * created 10.08.2023
 */
import React, {ReactElement} from 'react';

interface ViewWrapperComponentInterface {
  enable?: boolean;
  disable?: boolean;
  elseView?: ReactElement;
  children: any;
  dontRemove?: boolean;
}

function ViewWrapperComponent(
  props: ViewWrapperComponentInterface,
): ReactElement {
  const {enable, disable, children, dontRemove = false, elseView = <></>} = props;

  const isShow =
    (typeof enable === 'boolean' && enable) ||
    (typeof disable === 'boolean' && !disable);

  if (dontRemove) {
    return <div style={!isShow ? styles.hide : {}}>{isShow ? children : elseView}</div>;
  } else {
    return isShow ? children : elseView;
  }
}

export const ViewWrapper = ViewWrapperComponent;

const styles = {
  hide: {
    opacity: 0,
  },
};
